import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-store-assortimento',
    templateUrl: './assortimento.component.html',
    styleUrls: ['./assortimento.component.css']
})
//Pagina 32
export class AssortimentoComponent implements OnInit {

    items: MenuItem[];
    activeIndex: number;
    translations: any = {};

    constructor(private translate: TranslateService) {

        this.translate.get([
            'promo.overview'
        ]).subscribe((t) => {
            this.translations = {
                page_title: t['promo.overview']
            };
        });
    }

    ngOnInit() {
        this.activeIndex = 0;
        this.items = [];

        this.translate.get([
            'store.main_kpi'
        ]).subscribe((t) => {
            this.items.push(
                {
                    label: t['store.main_kpi'],
                    command: (event: any) => {
                        this.activeIndex = 0;
                    }
                }
            );
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/views/store/assortimento/assortimento.component.ts